import { render, staticRenderFns } from "./potentialRemindPlan.vue?vue&type=template&id=331c3664&scoped=true&"
import script from "./potentialRemindPlan.vue?vue&type=script&lang=js&"
export * from "./potentialRemindPlan.vue?vue&type=script&lang=js&"
import style0 from "./potentialRemindPlan.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./potentialRemindPlan.vue?vue&type=style&index=1&id=331c3664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c3664",
  null
  
)

component.options.__file = "potentialRemindPlan.vue"
export default component.exports